export default __webpack_public_path__ + "static/illustration-greatness-ee6e101b8ab2264e82385bc6f83ee129.svg";